class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          if (this.drawer.mainDetailsToggle?.hasAttribute('open')) this.drawer.focusDrawer();
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    if (!this.drawer) return;
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement?.hasAttribute('open') && !this.drawer.isClosing) {
      return;
    }
    
    this.drawer.openMenuDrawer(this.activeElement || document.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    let cartRendered = false;
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      const html = this.getSectionInnerHTML(parsedState.sections?.[section.id], section.selector);
      if (element && html != null) {
        element.innerHTML = html;
        if (section.id === 'mini-cart') cartRendered = true;
      }
    }));

    if (!cartRendered) {
      // A successful add can have a null section response; do not invite a duplicate retry.
      window.location.assign(theme.routes.cart_url);
      return false;
    }
    this.open();
    return true;
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string') return null;
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
